"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSideNav = exports.NAV_WIDTH_COLLAPSE = exports.SUB_NAV_WIDTH = exports.NAV_WIDTH = void 0;
const useSelfActions_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelfActions"));
const useAppState_1 = __importDefault(require("@opsbase/web-app-state/useAppState"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const react_1 = __importStar(require("react"));
const AppSideNavDrawer_1 = __importDefault(require("./AppSideNavDrawer"));
exports.NAV_WIDTH = 210;
exports.SUB_NAV_WIDTH = 180;
exports.NAV_WIDTH_COLLAPSE = 74;
const makeMyClasses = (depth = 0) => {
    const width = depth === 0
        ? exports.NAV_WIDTH
        : depth === 1
            ? exports.NAV_WIDTH_COLLAPSE + exports.SUB_NAV_WIDTH
            : depth === 2
                ? exports.NAV_WIDTH_COLLAPSE + exports.SUB_NAV_WIDTH + exports.SUB_NAV_WIDTH
                : 0;
    return {
        placeholder: {
            transition: 'width 0.32s',
            width,
        },
    };
};
function AppSideNav() {
    const { navs } = (0, useAppState_1.default)();
    const { isSelected } = (0, useNav_1.default)();
    const { hasFeature } = (0, useSelfActions_1.default)();
    const allowedNavs = (0, react_1.useMemo)(() => navs.filter(n => hasFeature(n.flag)), [hasFeature, navs]);
    const childNavs = (0, react_1.useMemo)(() => { var _a; return ((_a = allowedNavs === null || allowedNavs === void 0 ? void 0 : allowedNavs.find(isSelected)) === null || _a === void 0 ? void 0 : _a.children) || []; }, [allowedNavs, isSelected]);
    const grandchildNavs = (0, react_1.useMemo)(() => { var _a; return ((_a = childNavs === null || childNavs === void 0 ? void 0 : childNavs.find(isSelected)) === null || _a === void 0 ? void 0 : _a.children) || []; }, [childNavs, isSelected]);
    const depth = (grandchildNavs === null || grandchildNavs === void 0 ? void 0 : grandchildNavs.length) ? 2 : (childNavs === null || childNavs === void 0 ? void 0 : childNavs.length) ? 1 : 0;
    const myCss = (0, web_css_1.default)(makeMyClasses, [depth]);
    return (0, react_1.useMemo)(() => {
        if (allowedNavs.length <= 1)
            return null;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { key: "navPlaceholder", className: myCss.placeholder }),
            react_1.default.createElement(AppSideNavDrawer_1.default, { key: "navDrawer1", navs: allowedNavs, collapse: !!(childNavs === null || childNavs === void 0 ? void 0 : childNavs.length) }),
            react_1.default.createElement(AppSideNavDrawer_1.default, { key: "navDrawer2", depth: 1, navs: childNavs }),
            react_1.default.createElement(AppSideNavDrawer_1.default, { key: "navDrawer3", depth: 2, navs: grandchildNavs })));
    }, [childNavs, grandchildNavs, myCss, allowedNavs]);
}
exports.AppSideNav = AppSideNav;
exports.default = AppSideNav;
